import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import { Produto, CartItem } from '../tamas-models';
import {AlertaPremiumDialog} from '../alerta-premium';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-shop-pedidos',
  templateUrl: './shop-pedidos.component.html',
  styleUrls: ['./shop-pedidos.component.css']
})
export class ShopPedidosComponent implements OnInit, OnDestroy {

  hideCL: boolean = false;
  categoriaAtual: any = '';
  idProduto: any = 0;
  mUF: any = '';
  mCidade: any = '';
  urlFoto: any = '';
  arrMeusPedidos: any[] = [];
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router,  public tmaService: TamasAlunoService,  public dialog: MatDialog) { }


  ngOnInit() {
    //this.hideCL = true;
    this.tmaService.eventoFS(true);
    this.carregarPedidos();
  }

  ngOnDestroy() {
    this.tmaService.eventoFS(false);
  }


  carregarPedidos(){
    this.hideCL = false;
    var dadosBc = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha;
    this.tmaService.listarPedidos(dadosBc)
    .subscribe((qRes) =>{
      this.hideCL = true;
      console.log(qRes);
      if(qRes['res'] == 'done'){
        this.arrMeusPedidos = qRes['arrPedidos'];
      }
    })
  }
  voltar() :void{
    //this._location.back();
    if(this.tmaService.gUrlAnterior == ''){
      this.router.navigate(['/home']);
    }
    else{
      this.router.navigate([this.tmaService.gUrlAnterior]);
    }
    
  }

  goPedido(idpedido: any){
    this.router.navigate(['shopping/pedido/' + idpedido]);
  }

}
